import { BsExclamationTriangle } from "react-icons/bs";
import "./modal.css";

export const Modal = ({ show, onClose, title, content, footer }) => {
  const modalClassName = show ? "modal display-block" : "modal display-none";

  return (
    <div className={modalClassName} onClick={onClose}>
      <section
        className="modal-main"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="modal-header">
          <span className="modal-title">{title}</span>
          <button type="button" className="close-button" onClick={onClose}>
            &times;
          </button>
          <hr />
        </div>
        <div className="modal-content">{content}</div>
        <div className="modal-footer">
          <span className="modal-title">{footer}</span>
        </div>
      </section>
    </div>
  );
};

export const ErrorModal = ({ show, onClose, title, content }) => {
  const modalClassName = show ? "modal display-block" : "modal display-none";

  return (
    <div className={modalClassName} onClick={onClose}>
      <section
        className="modal-main error-modal"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="modal-header">
          <span className="modal-title">{title}</span>
          <button type="button" className="close-button" onClick={onClose}>
            &times;
          </button>
          <hr />
        </div>
        <div className="modal-content">
          <BsExclamationTriangle size={40} className="m-auto" />
          {content}
        </div>
      </section>
    </div>
  );
};

export default Modal;
